module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-LightItalic.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-LightItalic.woff2
// module id = 50
// module chunks = 8